// ----------------------------------------------------------------------

export const roles = {
    ADMIN: 'ROLE_ADMINISTRATOR',
    ADHOC: 'ROLE_ADHOC',
    ACCOUNTING: 'ROLE_ACCOUNTING',
    AMOUNTS_EDITOR: 'ROLE_AMOUNTS_EDITOR',
    ORG_ADMIN: 'ROLE_ORG_ADMIN',
    PAYCARD_ADMIN: 'ROLE_PAYCARD_ADMIN',
    PAYCARD_RAPID_ADMIN: 'ROLE_PAYCARD_RAPID_ADMIN',
    VIEW_REPORTS: 'ROLE_VIEW_REPORTS',
    STORE_ADMIN: 'ROLE_STORE_ADMIN',
    USER_ADMIN: 'ROLE_USER_ADMIN',
    AI: 'ROLE_AI',
    AI_DEMO: 'ROLE_AI_DEMO',
    AI_ADMIN: 'ROLE_AI_ADMIN',
    AI_GLOBAL: 'ROLE_AI_GLOBAL',
}

export const isAdmin = (user) => user?.roles?.includes(roles.ADMIN);
export const isDemoUser = (user) => user?.roles?.includes(roles.AI_DEMO);
export const hasPermissions = (user, requiredRoles) => {
    return requiredRoles.some(role => user?.roles?.includes(role)) || isAdmin(user);
};
// ----------------------------------------------------------------------
